export const NS_LOGO_URL = 'https://nsi-logos.s3.amazonaws.com/Northspyre-Logo-staging-prod.png';
export const DEV_LOGO_URL = 'https://nsi-logos.s3.amazonaws.com/Northspyre-Logo-only-dev.png';
